import { useWeb3React } from '@web3-react/core';
import { MetaMask } from '@web3-react/metamask';
import { useCallback, useState } from 'react';
import config from '../../config/config';

const useEtherWalletConnect = () => {
    const { account, isActive, connector } = useWeb3React();
    const [connecting, setConnecting] = useState(false);

    const connectWallet = useCallback(async () => {
        if (connecting || !connector) return;
        if (!(connector instanceof MetaMask)) {
            console.error('Not a MetaMask connector');
            return;
        }

        setConnecting(true);
        try {
            // MetaMask 연결 시도 및 체인 전환
            await connector.activate(config.ARBITRUM_CHAIN);
            alert('지갑 연결 성공');
        } catch (error) {
            console.error('Connection error:', error);
            alert('지갑 연결 실패');
        } finally {
            setConnecting(false);
        }
    }, [connector, connecting]);

    const disconnectWallet = useCallback(async () => {
        if (!connector) return;

        try {
            if (connector instanceof MetaMask) {
                await connector.deactivate();
            }
        } catch (error) {
            console.error('Error on disconnect:', error);
        }
    }, [connector]);

    // 현재 연결된 체인 ID 확인
    const getChainId = useCallback(async () => {
        if (!connector || !(connector instanceof MetaMask)) return null;
        try {
            const provider = await connector.provider;
            return provider?.chainId;
        } catch (error) {
            console.error('Error getting chainId:', error);
            return null;
        }
    }, [connector]);


    return {
        connectWallet,
        disconnectWallet,
        getChainId,
        active: isActive,
        account,
        connecting,
        isConnected: isActive && account !== null,
    };
};

export default useEtherWalletConnect;